// extracted by mini-css-extract-plugin
export var actionText = "_n4-4";
export var container = "_n4-0";
export var leftSection = "_n4-1";
export var rightSection = "_n4-2";
export var settingsButton = "_n4-6";
export var settingsIcon = "_n4-7";
export var shortcut = "_n4-5";
export var shortcutGroup = "_n4-3";